import { redirect } from '@tanstack/react-router';
import { createServerFn } from '@tanstack/react-start';
import { getRequest } from '@tanstack/react-start/server';

import { createServerFnObservabilityMiddleware } from '../utils/create-instrumented-server-fn.ts';
import { getAuthSession } from './session.server.ts';

export interface AuthPageData {
	readonly baseUrl: string;
}

export const getAuthPageData = createServerFn({ method: 'GET' })
	.middleware([
		createServerFnObservabilityMiddleware({
			dependencies: ['auth.session'],
			relatesTo: 'auth.page',
		}),
	])
	.handler(async () => {
		const request = getRequest();
		const authSession = await getAuthSession(request);

		if (authSession?.accessToken && authSession.refreshToken) {
			throw redirect({ href: '/dashboard' });
		}

		return {
			baseUrl: new URL(request.url).origin,
		} satisfies AuthPageData;
	});
